<template>
  <div class="settings-container">
    <div class="settings">
      <div
        v-for="(settingsGroup, i) in filteredSettings"
        :key="i"
        class="settings-group"
      >
        <div class="settings-group-header">
          <i class="fas" :class="settingsGroup.icon" aria-hidden="true"></i>
          <h4 class="settings-group-title ml-2">{{ settingsGroup.name }}</h4>
        </div>
        <ul class="settings-group-items">
          <li
            v-for="(item, j) in settingsGroup.items"
            :key="j"
            @click.prevent="item.onClick"
            class="setting-item text-primary"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import GenericSettingCrud from "./GenericSettingCrud";
import UserCrud from "./UserCrud.vue";
import RoleCrud from "./RoleCrud.vue";
import NotificationsConfig from "./NotificationsConfig.vue";
import VitalSignCrud from "./VitalSignCrud.vue";
import EocBadgeCrud from "./EocBadgeCrud.vue";
import EocBadgeCategoryCrud from "./EocBadgeCategoryCrud.vue";
import GroupSessionTypeCrud from "./GroupSessionTypeCrud.vue";
import NutritionalItemCrud from "./NutritionalItemCrud.vue";
import DiagnosisCodeICDCodeCrud from "./DiagnosisCodeICDCodeCrud.vue";
import EocLevelOfCareCrud from "./EocLevelOfCareCrud.vue";
import ServiceCrud from "./ServiceCrud.vue";
import EocSidebarFolderCrud from "./EocSidebarFolderCrud.vue";
//import ReportsDesigner from "./ReportsDesigner";
import TaxonomyCrud from "./TaxonomyCrud";
import LocationCrud from "./LocationCrud";
import InsuranceCompanyCrud from "./InsuranceCompanyCrud.vue";
import InsuranceCompanyPlanCrud from "./InsuranceCompanyPlanCrud.vue";
import RoomCrud from "./RoomCrud.vue";
import CaseRoleCrud from "./CaseRoleCrud.vue";
import MedicationCrud from "./MedicationCrud.vue";
import FormList from "../../../../Breeze.FormBuilder.Frontend/components/form_builder/FormList.vue";
import FormBuilderAddEdit from "../../../../Breeze.FormBuilder.Frontend/components/form_builder/FormBuilderAddEdit.vue";
import FormBuilderCollectionCrud from "./FormBuilderCollectionCrud.vue";
import FormBuilderTemplateEditor from "./FormBuilderTemplateEditor.vue";
import FormGroupCrud from "./FormGroupCrud.vue";
import DeletedPatients from "./DeletedPatients";
import DeletedDocuments from "./DeletedDocuments";
import UtilizationStatusCrud from "./UtilizationStatusCrud";
import PredefinedProtocolCrud from "./PredefinedProtocolCrud";
import MovePatient from "./MovePatient";
import PatientPortal from "./PatientPortal";
import SharePackageCrud from "./SharePackageCrud";
import DischargeReasonCrud from "./DischargeReasonCrud.vue";
import Organization from "./Organization";

export default {
  name: "SettingsIndex",
  components: {},
  props: ["showing"],
  data: () => ({
    allergyTypeSetting: {
      key: "allergyTypes",
      title: "Allergy Types",
      singularTitle: "Allergy Type",
      path: "AllergyType",
      fetchAction: "fetchAllergyTypes",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    allergySeveritySetting: {
      key: "allergySeveritys",
      title: "Allergy Severities",
      singularTitle: "Allergy Severity",
      path: "AllergySeverity",
      fetchAction: "fetchAllergySeverities",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    allergenSetting: {
      key: "allergens",
      title: "Allergens",
      singularTitle: "Allergen",
      path: "Allergen",
      fetchAction: "fetchAllergens",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    reactionSetting: {
      key: "reactions",
      title: "Allergy Reactions",
      singularTitle: "Allergy Reaction",
      path: "Reaction",
      fetchAction: "fetchReactions",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    nutritionCategorySetting: {
      key: "nutritionCategories",
      title: "Nutritional Item Categories",
      singularTitle: "Nutritional Item Category",
      path: "NutritionCategory",
      fetchAction: "fetchNutritionCategories",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    nutritionMealSetting: {
      key: "nutritionMeals",
      title: "Meals",
      singularTitle: "Meal",
      path: "NutritionMeal",
      fetchAction: "fetchNutritionMeals",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    insuranceCoverageSetting: {
      key: "insuranceStatus",
      title: "Insurance Coverage Types",
      singularTitle: "Insurance Coverage Type",
      path: "InsuranceCoverage",
      fetchAction: "fetchInsuranceCoverages",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    maritalStatusSetting: {
      key: "maritalStatus",
      title: "Marital Status",
      singularTitle: "Marital Status",
      path: "MaritalStatus",
      fetchAction: "fetchMaritalStatuses",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    genderSetting: {
      key: "genders",
      title: "Legal Sexes",
      singularTitle: "Legal Sex",
      path: "Gender",
      fetchAction: "fetchGenders",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    credentialSetting: {
      key: "credentials",
      title: "Credentials",
      singularTitle: "Credential",
      path: "Credential",
      fetchAction: "fetchCredentials",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    pronounSetting: {
      key: "pronouns",
      title: "Pronouns",
      singularTitle: "Pronoun",
      path: "Pronoun",
      fetchAction: "fetchPronouns",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    relationshipSetting: {
      key: "relationships",
      title: "Relationships",
      singularTitle: "Relationship",
      path: "Relationships",
      fetchAction: "fetchRelationships",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    stateSetting: {
      key: "states",
      title: "States",
      singularTitle: "State",
      path: "State",
      fetchAction: "fetchStates",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    medicationSetting: {
      key: "medication",
      title: "Medications",
      singularTitle: "Medication",
      path: "Medication",
      fetchAction: "fetchMedications",
      search: true,
      pagination: true
    },
    medicationRouteSetting: {
      key: "medicationRoute",
      title: "Medication Routes",
      singularTitle: "Medication Route",
      path: "MedicationRoute",
      fetchAction: "fetchMedicationRoutes",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    unitOfMeasurementsSetting: {
      key: "unitOfMeasurement",
      title: "Measurements",
      singularTitle: "Measurement",
      path: "UnitOfMeasurement",
      fetchAction: "fetchMeasurements",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    taxonomySpecialtiesSetting: {
      key: "taxonomySpeciality",
      title: "Taxonomy Specialties",
      singularTitle: "Taxonomy Specialty",
      path: "TaxonomySpecialty",
      fetchAction: "fetchTaxonomySpecialty",
      search: false,
      pagination: false,
      nameMaxLength: 300
    },
    taxonomyTypesSetting: {
      key: "taxonomyType",
      title: "Taxonomy Types",
      singularTitle: "Taxonomy Type",
      path: "TaxonomyType",
      fetchAction: "fetchTaxonomyTypes",
      search: false,
      pagination: false,
      nameMaxLength: 300
    },
    entityTypeSetting: {
      key: "entityType",
      title: "Entity Types",
      singularTitle: "Entity Type",
      path: "EntityType",
      fetchAction: "fetchEntityTypes",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    payerTypeSetting: {
      key: "payerType",
      title: "Payer Types",
      singularTitle: "Payer Type",
      path: "PayerTypes",
      fetchAction: "fetchPayerTypes",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    raceSetting: {
      key: "race",
      title: "Races",
      singularTitle: "Race",
      path: "Race",
      fetchAction: "fetchRaces",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    ethnicitySetting: {
      key: "ethnicity",
      title: "Ethnicities",
      singularTitle: "Ethnicity",
      path: "Ethnicity",
      fetchAction: "fetchEthnicities",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    languageSetting: {
      key: "language",
      title: "Languages",
      singularTitle: "Language",
      path: "Language",
      fetchAction: "fetchLanguages",
      search: false,
      pagination: false,
      nameMaxLength: 40
    },
    roomsSetting: {
      key: "rooms",
      title: "Rooms",
      singularTitle: "Room",
      path: "Room",
      fetchAction: "fetchRooms",
      search: false,
      pagination: false,
      nameMaxLength: 100
    },
    insuranceCompanyPlansSetting: {
      key: "insuranceCompanyPlans",
      title: "Insurance Company Plans",
      singularTitle: "Plans",
      path: "InsuranceCompanyPlans",
      fetchAction: "fetchPlans",
      search: false,
      pagination: false,
      nameMaxLength: 100
    }
  }),
  methods: {
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    hasAccess(key) {
      return this.hasCurrentUserPermissionAccess("settings", key);
    },
    openSetting(setting) {
      this.$emit("add-tab", {
        key: "setting-" + setting.key,
        text: setting.title,
        component: GenericSettingCrud,
        props: {
          settingData: setting
        },
        closeable: true
      });
    },
    openCustomCrud(key, text, component, props = {}) {
      this.$emit("add-tab", {
        key: key,
        text: text,
        component: component,
        props: props,
        closeable: true
      });
    },
    openFormBuilder(title, category = "main") {
      this.openCustomCrud(
        "form-builder-" + category.toLowerCase(),
        title,
        FormList,
        { category, title }
      );
    },
    openFacilityTemplatesEditor(name, property) {
      this.openCustomCrud(
        `setting-${property}`,
        name,
        FormBuilderTemplateEditor,
        { name, property }
      );
    },
    openGroupSessionForm() {
      const forms = this.forms["groupSession"];
      if (forms.length > 0) {
        this.openCustomCrud(
          "group-note-form",
          "Group Note Form",
          FormBuilderAddEdit,
          {
            id: forms[0].id,
            category: "groupSession"
          }
        );
      }
    },
    openEOCAdditionalInfoForm() {
      const forms = this.forms["eocAdditionalInfo"];
      if (forms.length > 0) {
        this.openCustomCrud(
          "additional-information-form",
          "Additional Information Form",
          FormBuilderAddEdit,
          { id: forms[0].id, category: "eocAdditionalInfo" }
        );
      }
    },
    openMasterTreatmentPlanForm() {
      const forms = this.forms["masterTreatmentPlan"];
      if (forms.length > 0) {
        this.openCustomCrud(
          "master-treatment-plan-form",
          "Master Treatment Plan Form",
          FormBuilderAddEdit,
          { id: forms[0].id, category: "masterTreatmentPlan" }
        );
      }
    },
    openDoctorOrderForm() {
      const forms = this.forms["doctorOrder"];
      if (forms.length > 0) {
        this.openCustomCrud(
          "doctor-order-form",
          "Doctor Order Form",
          FormBuilderAddEdit,
          { id: forms[0].id, category: "doctorOrder" }
        );
      }
    },
    openReleaseOfInformationForm() {
      const forms = this.forms["releaseOfInformation"];
      if (forms.length > 0) {
        this.openCustomCrud(
          "release-of-information",
          "Release Of Information Forms",
          FormBuilderAddEdit,
          { id: forms[0].id, category: "releaseOfInformation" }
        );
      }
    },
    filteredSettingsPermissions(setting) {
      if (setting.name === "Medications") {
        return !this.isEMAREnabled;
      }
      return true;
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"]),
    ...mapState("formBuilder", {
      forms: state => state.list
    }),
    ...mapState("layout", {
      advancedOptions: state => state.advancedOptions,
      isEMAREnabled: state => state.systemSetting?.emarEnabled
    }),
    settings() {
      return [
        {
          name: "General",
          icon: "fa-briefcase",
          items: [
            {
              name: "Organization",
              hasAccess: this.hasAccess("organization"),
              onClick: () =>
                this.openCustomCrud(
                  "organization",
                  "Organization",
                  Organization
                )
            },
            {
              name: "Locations",
              hasAccess: this.hasAccess("locations"),
              onClick: () =>
                this.openCustomCrud("locations", "Locations", LocationCrud)
            },
            {
              name: "Levels Of Care",
              hasAccess: this.hasAccess("levelsOfCare"),
              onClick: () =>
                this.openCustomCrud(
                  "levels-of-care",
                  "Levels of Care",
                  EocLevelOfCareCrud
                )
            },
            {
              name: "Utilization Status",
              hasAccess: this.hasAccess("urStatus"),
              onClick: () =>
                this.openCustomCrud(
                  "utilization-status",
                  "Utilization Status",
                  UtilizationStatusCrud
                )
            },
            {
              name: "Services",
              hasAccess: this.hasAccess("service"),
              onClick: () =>
                this.openCustomCrud("services", "Services", ServiceCrud)
            },
            {
              name: "Rooms & Beds",
              hasAccess: this.hasAccess("locations"),
              onClick: () =>
                this.openCustomCrud("rooms-beds", "Rooms & Beds", RoomCrud)
            },
            {
              name: "Patient Menu Structure",
              hasAccess: this.hasAccess("forms"),
              onClick: () =>
                this.openCustomCrud(
                  "patient-folders",
                  "Patient Menu Structure",
                  EocSidebarFolderCrud
                )
            },
            {
              name: "Case Roles",
              hasAccess: this.hasAccess("caseRoles"),
              onClick: () =>
                this.openCustomCrud("case-roles", "Case Roles", CaseRoleCrud)
            },
            {
              name: "Rooms",
              hasAccess: this.hasAccess(this.roomsSetting.key),
              onClick: () => this.openSetting(this.roomsSetting)
            },
            {
              name: "Discharge Reasons",
              hasAccess: this.hasAccess("dischargeReasons"),
              onClick: () =>
                this.openCustomCrud(
                  "discharge-reasons",
                  "Discharge Reasons",
                  DischargeReasonCrud
                )
            },
            {
              name: "Patient Portal",
              hasAccess: this.hasAccess("patientPortal"),
              onClick: () =>
                this.openCustomCrud(
                  "patient-portal",
                  "Patient Portal",
                  PatientPortal
                )
            }
          ]
        },
        {
          name: "Security",
          icon: "fa-lock",
          items: [
            {
              name: "Users",
              hasAccess: this.hasAccess("users"),
              onClick: () => this.openCustomCrud("users", "Users", UserCrud)
            },
            {
              name: "Roles & Permissions",
              hasAccess: this.hasAccess("roles"),
              onClick: () => this.openCustomCrud("roles", "Roles", RoleCrud)
            },
            {
              name: "Notifications",
              hasAccess: this.hasAccess("roles"),
              onClick: () =>
                this.openCustomCrud(
                  "notifications",
                  "Notifications",
                  NotificationsConfig
                )
            }
          ]
        },
        {
          name: "Insurance",
          icon: "fa-id-card",
          items: [
            {
              name: "Insurance Companies",
              hasAccess: this.hasAccess("insuranceCompanies"),
              onClick: () =>
                this.openCustomCrud(
                  "insurance-companies",
                  "Insurance Companies",
                  InsuranceCompanyCrud
                )
            },
            {
              name: "Insurance Company Plans",
              hasAccess: this.hasAccess("insuranceCompanies"),
              onClick: () =>
                this.openCustomCrud(
                  "insurance-company-plans",
                  "Insurance Company Plans",
                  InsuranceCompanyPlanCrud
                )
            },
            {
              name: "Payer Types",
              hasAccess: this.hasAccess(this.insuranceCoverageSetting.key),
              onClick: () => this.openSetting(this.payerTypeSetting)
            }
          ]
        },
        {
          name: "Patients",
          icon: "fa-users",
          items: [
            {
              name: "Badges",
              hasAccess: this.hasAccess("badge"),
              onClick: () =>
                this.openCustomCrud("badges", "Badges", EocBadgeCrud)
            },
            {
              name: "Badge Categories",
              hasAccess: this.hasAccess("badgeCategory"),
              onClick: () =>
                this.openCustomCrud(
                  "badge-categories",
                  "Badge Categories",
                  EocBadgeCategoryCrud
                )
            },
            {
              name: "Additional Information Form",
              hasAccess: this.hasAccess("forms"),
              onClick: () => this.openEOCAdditionalInfoForm()
            },
            {
              name: "Vital Signs",
              hasAccess: this.hasAccess(this.relationshipSetting.key),
              onClick: () =>
                this.openCustomCrud("vital-signs", "Vital Signs", VitalSignCrud)
            },
            {
              name: "Move patient",
              hasAccess: this.hasAccess("movePatient"),
              onClick: () =>
                this.openCustomCrud("move-patient", "Move patient", MovePatient)
            }
          ]
        },
        {
          name: "Deleted Data",
          icon: "fa-users",
          items: [
            {
              name: "Patients",
              hasAccess: this.hasAccess("badge"), //deletedPatients
              onClick: () =>
                this.openCustomCrud(
                  "deleted-patients",
                  "Deleted Patients",
                  DeletedPatients
                )
            },
            {
              name: "Documents",
              hasAccess: this.hasAccess("badge"), //deletedPatients
              onClick: () =>
                this.openCustomCrud(
                  "deleted-documents",
                  "Deleted Documents",
                  DeletedDocuments
                )
            }
          ]
        },
        {
          name: "Groups",
          icon: "fa-users",
          items: [
            {
              name: "Group Types",
              hasAccess: this.hasAccess("forms"),
              onClick: () =>
                this.openCustomCrud(
                  "group-types",
                  "Group Types",
                  GroupSessionTypeCrud
                )
            },
            {
              name: "Group Note Header Template",
              hasAccess: this.hasAccess("forms") && this.advancedOptions,
              onClick: () =>
                this.openFacilityTemplatesEditor(
                  "Group Note Header Template",
                  "groupSessionHeader"
                )
            }
          ]
        },
        {
          name: "Allergies",
          icon: "fa-exclamation-triangle",
          items: [
            {
              name: "Allergy Types",
              hasAccess: this.hasAccess(this.allergyTypeSetting.key),
              onClick: () => this.openSetting(this.allergyTypeSetting)
            },
            {
              name: "Allergy Severities",
              hasAccess: this.hasAccess(this.allergySeveritySetting.key),
              onClick: () => this.openSetting(this.allergySeveritySetting)
            },
            {
              name: "Allergens",
              hasAccess: this.hasAccess(this.allergenSetting.key),
              onClick: () => this.openSetting(this.allergenSetting)
            },
            {
              name: "Allergy Reactions",
              hasAccess: this.hasAccess(this.reactionSetting.key),
              onClick: () => this.openSetting(this.reactionSetting)
            }
          ]
        },
        {
          name: "Documents & Forms",
          icon: "fa-file-text",
          items: [
            {
              name: "Form Builder",
              hasAccess: this.hasAccess("forms"),
              onClick: () => this.openFormBuilder("Form Builder")
            },
            {
              name: "Form Groups",
              hasAccess: this.hasAccess("forms"),
              onClick: () =>
                this.openCustomCrud("form-groups", "Form Groups", FormGroupCrud)
            },
            {
              name: "Form Header Template",
              hasAccess: this.hasAccess("forms") && this.advancedOptions,
              onClick: () =>
                this.openFacilityTemplatesEditor(
                  "Form Header Template",
                  "formHeader"
                )
            },
            {
              name: "Collections",
              hasAccess: this.hasAccess("collections"),
              onClick: () =>
                this.openCustomCrud(
                  "collections",
                  "Collections",
                  FormBuilderCollectionCrud
                )
            },
            {
              name: "Treatment Plan Forms",
              hasAccess: this.hasAccess("forms"),
              onClick: () =>
                this.openFormBuilder(
                  "Treatment Plan Forms",
                  "masterTreatmentPlan"
                )
            },
            {
              name: "Doctor Order Forms",
              hasAccess: this.hasAccess("forms") && !this.isEMAREnabled,
              onClick: () =>
                this.openFormBuilder("Doctor Order Forms", "doctorOrder")
            },
            {
              name: "Release Of Information Forms",
              hasAccess: this.hasAccess("forms"),
              onClick: () =>
                this.openFormBuilder(
                  "Release Of Information Forms",
                  "releaseOfInformation"
                )
            },
            {
              name: "Document Packages",
              hasAccess: this.hasAccess("forms"),
              onClick: () =>
                this.openCustomCrud(
                  "share-package",
                  "Document Packages",
                  SharePackageCrud
                )
            }
          ]
        },
        // {
        //  name: "Reports",
        //  icon: "fa-table",
        //  items: [
        /* {
              name: "Reports",
              hasAccess: this.hasAccess("forms"),
              onClick: () => this.openCustomCrud("reports", "Reports", Reports)
            }, */
        //    {
        //     name: "Report designer",
        //     hasAccess: this.hasAccess("forms"),
        //     onClick: () =>
        //       this.openCustomCrud(
        //         "report-designer",
        //        "Report Designer",
        //       ReportsDesigner
        //       )
        //   }
        //  ]
        // },
        {
          name: "Nutritional journal",
          icon: "fa-book",
          items: [
            {
              name: "Nutritional Item Categories",
              hasAccess: this.hasAccess(this.nutritionCategorySetting.key),
              onClick: () => this.openSetting(this.nutritionCategorySetting)
            },
            {
              name: "Nutritional Items",
              hasAccess: this.hasAccess(this.nutritionCategorySetting.key),
              onClick: () =>
                this.openCustomCrud(
                  "nutritional-items",
                  "Nutritional Items",
                  NutritionalItemCrud
                )
            },
            {
              name: "Meals",
              hasAccess: this.hasAccess(this.nutritionMealSetting.key),
              onClick: () => this.openSetting(this.nutritionMealSetting)
            }
          ]
        },
        {
          name: "Taxonomy",
          icon: "fa-bars",
          items: [
            {
              name: "Taxonomies",
              hasAccess: this.hasAccess("icdCodes"),
              onClick: () =>
                this.openCustomCrud("taxonomies", "Taxonomies", TaxonomyCrud)
            },
            {
              name: "Taxonomy Types",
              hasAccess: this.hasAccess("icdCodes"),
              onClick: () => this.openSetting(this.taxonomyTypesSetting)
            },
            {
              name: "Taxonomy Specialties",
              hasAccess: this.hasAccess("icdCodes"),
              onClick: () => this.openSetting(this.taxonomySpecialtiesSetting)
            }
          ]
        },
        {
          name: "Medications",
          icon: "fa-briefcase",
          items: [
            {
              name: "Medications",
              hasAccess: this.hasAccess("medication"),
              onClick: () =>
                this.openCustomCrud("medication", "Medications", MedicationCrud)
            },
            {
              name: "Medication routes",
              hasAccess: this.hasAccess(this.medicationRouteSetting.key),
              onClick: () => this.openSetting(this.medicationRouteSetting)
            },
            {
              name: "Units of measurement",
              hasAccess: this.hasAccess(this.unitOfMeasurementsSetting.key),
              onClick: () => this.openSetting(this.unitOfMeasurementsSetting)
            },
            {
              name: "Predefined Protocols",
              hasAccess: this.hasAccess("medication"),
              onClick: () =>
                this.openCustomCrud(
                  "predefined-protocol",
                  "Predefined Protocols",
                  PredefinedProtocolCrud
                )
            }
          ]
        },
        {
          name: "Other",
          icon: "fa-book",
          items: [
            {
              name: "States",
              hasAccess: this.hasAccess(this.stateSetting.key),
              onClick: () => this.openSetting(this.stateSetting)
            },
            {
              name: "ICD Codes",
              hasAccess: this.hasAccess("icdCodes"),
              onClick: () =>
                this.openCustomCrud(
                  "icd-codes",
                  "ICD Codes",
                  DiagnosisCodeICDCodeCrud
                )
            },
            {
              name: "Entity Types",
              hasAccess: this.hasAccess("icdCodes"),
              onClick: () => this.openSetting(this.entityTypeSetting)
            },
            {
              name: "Legal Sexes",
              hasAccess: this.hasAccess(this.genderSetting.key),
              onClick: () => this.openSetting(this.genderSetting)
            },
            {
              name: "Credentials",
              hasAccess: this.hasAccess(this.credentialSetting.key),
              onClick: () => this.openSetting(this.credentialSetting)
            },
            {
              name: "Pronouns",
              hasAccess: this.hasAccess(this.pronounSetting.key),
              onClick: () => this.openSetting(this.pronounSetting)
            },
            {
              name: "Relationships",
              hasAccess: this.hasAccess(this.relationshipSetting.key),
              onClick: () => this.openSetting(this.relationshipSetting)
            },
            {
              name: "Marital Status",
              hasAccess: this.hasAccess(this.maritalStatusSetting.key),
              onClick: () => this.openSetting(this.maritalStatusSetting)
            },
            {
              name: "Races",
              hasAccess: this.hasAccess(this.raceSetting.key),
              onClick: () => this.openSetting(this.raceSetting)
            },
            {
              name: "Ethnicities",
              hasAccess: this.hasAccess(this.ethnicitySetting.key),
              onClick: () => this.openSetting(this.ethnicitySetting)
            },
            {
              name: "Languages",
              hasAccess: this.hasAccess(this.languageSetting.key),
              onClick: () => this.openSetting(this.languageSetting)
            }
          ]
        }
      ];
    },
    filteredSettings() {
      return this.settings.reduce((acc, sg) => {
        const items = sg.items.filter(item => item.hasAccess);
        if (items.length) {
          acc.push({ ...sg, items });
        }
        return acc;
      }, [])
      .filter(sg => this.filteredSettingsPermissions(sg));
    }
  },
  watch: {
    showing: {
      handler: function(value) {
        if (value) {
          this.fetchFormBuilderForms({ category: "groupSession" });
          this.fetchFormBuilderForms({ category: "eocAdditionalInfo" });
          this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
          this.fetchFormBuilderForms({ category: "doctorOrder" });
          this.fetchFormBuilderForms({ category: "releaseOfInformation" });
        }
      }
    }
  }
};
</script>

<style lang="scss">
.settings-container {
  padding: 40px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f5f8fc;
  max-height: calc(100vh - 169px);

  .settings {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 30px;
    width: min-content;

    @media (min-width: 1000px) {
      max-height: 1475px;
    }

    @media (min-width: 1380px) {
      max-height: 950px;
    }

    @media (min-width: 1755px) {
      max-height: 800px;
    }
  }

  .settings-group {
    padding: 35px;
    border-radius: 10px;
    background-color: white;
    width: 350px;
  }

  .settings-group-header {
    display: flex;
    align-items: center;
  }

  .settings-group-title {
    font-size: 16px;
    line-height: 1;
    margin: 0;
  }

  .settings-group-items {
    margin: 15px 0 0;
    padding: 0 0 0 19px;
    list-style: none;
  }

  .setting-item {
    font-size: 13px;
    margin-top: 5px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &:before {
      content: "\2022";
      color: black;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
  }
}
</style>
